import { render, staticRenderFns } from "./PercentLoading.vue?vue&type=template&id=15c84808&"
import script from "./PercentLoading.vue?vue&type=script&lang=js&"
export * from "./PercentLoading.vue?vue&type=script&lang=js&"
import style0 from "./PercentLoading.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports